import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import MaterialButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { DataGrid } from '@mui/x-data-grid';

import { Auth } from "aws-amplify";

import "@aws-amplify/ui-react/styles.css";

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { postEmployee, getAllFromUserPool } from "../services/UserService";

const columns = [
  { field: 'Username', headerName: 'Brukernavn', width: 200 },
  {
    field: 'Name',
    headerName: 'Navn',
    width: 200,
    editable: false,
  },
  {
    field: 'LastName',
    headerName: 'Etternavn',
    width: 200,
    editable: false,
  },
  {
    field: 'Email',
    headerName: 'Email',
    width: 200,
    editable: false,
  },
  {
    field: 'Locale',
    headerName: 'Gruppetilgang',
    width: 200,
    editable: false,
  },
];

export default function Employees() {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [shownData, setShownData] = useState([]);
  const [group, setGroup] = React.useState('');
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [isNew, setIsNew] = useState(true);
  const [userInst, setUserInst] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [isLoadingEmployees, setIsLoadingEmployees] = useState(true);

  // State for error messages
  const [errors, setErrors] = useState({
    name: '',
    lastname: '',
    email: '',
  });

  useEffect(() => {
    getInst();
  }, []);

  const getUserData = async (inst) => {
    try {
      const data = await getAllFromUserPool(inst)

      if (!data || !Array.isArray(data)) {
        return
      }

      const mappedUserData = data.map(user => {
        const emailAttribute = user.Attributes.find(attribute => attribute.Name === "email");
        const email = emailAttribute ? emailAttribute.Value : 'N/A';
        const localeAttribute = user.Attributes.find(attribute => attribute.Name === "locale");
        const locale = localeAttribute ? localeAttribute.Value : 'Ikke oppgitt';
        const nameAttribute = user.Attributes.find(attribute => attribute.Name === "name");
        const name = nameAttribute ? nameAttribute.Value : 'Ikke oppgitt';
        const lastNameAttribute = user.Attributes.find(attribute => attribute.Name === "family_name");
        const lastName = lastNameAttribute ? lastNameAttribute.Value : 'Ikke oppgitt';
        return {
          ...user,
          Email: email,
          Locale: locale,
          Name: name,
          LastName: lastName,
        };
      });

      setShownData(mappedUserData);
    } finally {
      setIsLoadingEmployees(false);
    }
  };

  const getInst = async () => {
    let user = await Auth.currentAuthenticatedUser();
    setUserInst(user.attributes.zoneinfo);
    getUserData(user.attributes.zoneinfo);
  };

  const handleRowClick = (e) => {
    setDialogTitle("Rediger ansatt");
    setOpen(true);
    setName(e.row.Name);
    setLastName(e.row.LastName);
    setEmail(e.row.Email);
    setGroup(e.row.Locale);
    setIsNew(false);
  };

  function ShowGroup() {
    switch (userInst) {
      case '01':
        return (
          <FormControl fullWidth size="small">
            <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
              Gruppe <span style={{ color: '#439AC2' }}>*</span>
            </Typography>
            <Select
              labelId="employee-group-label"
              id="employee-group"
              value={group}
              label=""
              onChange={selectHandleChange}
            >
              <MenuItem value={"2C"}>2C</MenuItem>
              <MenuItem value={"2D"}>2D</MenuItem>
              <MenuItem value={"2E"}>2E</MenuItem>
              <MenuItem value={"1A"}>1A</MenuItem>
              <MenuItem value={"1B"}>1B</MenuItem>
              <MenuItem value={"ALL"}>Alle</MenuItem>
              <MenuItem value={"TEST"}>TEST</MenuItem>
            </Select>
          </FormControl>
        );
      case '02':
        return null;
    }
  }

  const selectHandleChange = (event) => {
    setGroup(event.target.value);
  };

  const pNRHandleChange = (event) => {
    setEmail(event.target.value);
  };

  const nameHandleChange = (event) => {
    setName(event.target.value);
    setErrors((prev) => ({ ...prev, name: '' })); // Clear error on change
  };

  const lastnameHandleChange = (event) => {
    setLastName(event.target.value);
    setErrors((prev) => ({ ...prev, lastname: '' })); // Clear error on change
  };

  const handleClickOpen = () => {
    if (!isNew) {
      setName("");
      setEmail("");
      setIsNew(true);
    } else {
      setName("");
    }

    setDialogTitle("Ny ansatt");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setErrors({ name: '', lastname: '', email: '' }); // Reset errors on close
  };

  // Validation function
  const validateFields = () => {
    let valid = true;
    let newErrors = { name: '', lastname: '', email: '' };

    if (!name) {
      valid = false;
      newErrors.name = 'Fornavn er påkrevd.';
    }
    if (!lastname) {
      valid = false;
      newErrors.lastname = 'Etternavn er påkrevd.';
    }
    if (!email) {
      valid = false;
      newErrors.email = 'Epost er påkrevd.';
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSave = () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    setOpen(false);
    let user_object = {
      email: email,
      name: name,
      locale: group,
      lastname: lastname,
      zoneinfo: userInst,
    };

    console.log("Date " + user_object.email);
    postEmployee(user_object);
  };

  const handleDelete = () => {
    setOpen(false);
    let user_object = {
      email: email,
      name: name,
      locale: group,
      lastname: lastname,
      zoneinfo: userInst,
    };
    postEmployee(user_object, 'DELETE');
  };

  const searchableData = shownData.filter((row) => {
    const search = searchValue.trim().toLowerCase();
    return !search || [row.Username, row.Name, row.LastName, row.Email]
      .some((value) => String(value || '').toLowerCase().includes(search));
  });

  const showLoadingState = isLoadingEmployees;

  return (
    <Box sx={{ height: '100%', minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#FFFFFF' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, width: '100%', padding: '0 24px 16px', boxSizing: 'border-box' }}>
        <TextField
          size="small"
          value={searchValue}
          onChange={(event) => setSearchValue(event.target.value)}
          placeholder="Søk på brukernavn eller navn"
          inputProps={{ 'aria-label': 'Søk på brukernavn eller navn' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{
            width: 545,
            '& .MuiOutlinedInput-root': {
              height: 40,
              borderRadius: '10px',
              '& fieldset': { borderColor: '#E5E7EB' },
              '&:hover fieldset': { borderColor: '#CBD5E1' },
              '&.Mui-focused fieldset': { borderColor: '#CBD5E1' },
            },
            '& .MuiInputBase-input': { fontSize: 14 },
          }}
        />
        <MaterialButton
          variant="contained"
          onClick={handleClickOpen}
          startIcon={<PersonAddAlt1Icon sx={{ fontSize: 18 }} />}
          sx={{
            height: 40,
            minWidth: 200,
            borderRadius: '10px',
            textTransform: 'none',
            fontSize: 14,
            fontWeight: 700,
            bgcolor: '#BDECF3',
            color: '#087D9A',
            boxShadow: 'none',
            '&:hover': { bgcolor: '#A9E3EC', boxShadow: 'none' },
          }}
        >
          Opprett ny ansatt
        </MaterialButton>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: 770,
            borderRadius: '14px',
            backgroundColor: '#F8FCFE',
            border: '1px solid #D7EAF1',
            overflow: 'hidden',
            boxShadow: '0 20px 50px rgba(15, 23, 42, 0.2)',
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#FFFFFF',
              borderRadius: '14px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9FC8DA',
              borderWidth: '3px',
              borderRadius: '14px',
            },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9FC8DA',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9FC8DA',
            },
          },
        }}
      >
        <Box sx={{ mx: 3, my: 2.5, overflow: 'hidden', border: '1px solid #D7EAF1', borderRadius: '14px', backgroundColor: '#FFFFFF' }}>
          <DialogTitle sx={{ px: 5, pt: 4, pb: 1, color: '#17233D', fontSize: 28, fontWeight: 700 }}>
            {dialogTitle}
          </DialogTitle>
          <DialogContent sx={{ px: 5, py: 1.5 }}>
            <DialogContentText sx={{ mb: 2.5, color: '#687895', fontSize: 18 }}>
              Legg inn nødvendige ansattopplysninger. Alle felt er obligatoriske.
            </DialogContentText>
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
                Fornavn <span style={{ color: '#439AC2' }}>*</span>
              </Typography>
              <TextField
                autoFocus
                id="name"
                fullWidth
                type="text"
                variant="outlined"
                value={name}
                onChange={nameHandleChange}
                required
                error={!!errors.name}
                helperText={errors.name}
              />
            </Box>
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
                Etternavn <span style={{ color: '#439AC2' }}>*</span>
              </Typography>
              <TextField
                id="lastname"
                fullWidth
                type="text"
                variant="outlined"
                value={lastname}
                onChange={lastnameHandleChange}
                required
                error={!!errors.lastname}
                helperText={errors.lastname}
              />
            </Box>
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
                Epost <span style={{ color: '#439AC2' }}>*</span>
              </Typography>
              <TextField
                id="email"
                fullWidth
                type="email"
                variant="outlined"
                value={email}
                onChange={pNRHandleChange}
                required
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>
            <ShowGroup />
          </DialogContent>
          <DialogActions sx={{ px: 5, py: 2.5, borderTop: '1px solid #E5EAF1', justifyContent: 'flex-end', gap: 1.5 }}>
            <MaterialButton
              color="error"
              disabled={isNew}
              onClick={handleDelete}
              sx={{ ml: 0, mr: 'auto', fontSize: 15, fontWeight: 700, textTransform: 'none' }}
            >
              Slett
            </MaterialButton>
            <MaterialButton onClick={handleClose} sx={{ color: '#00A8C6', fontSize: 16, fontWeight: 700, textTransform: 'none' }}>
              Avbryt
            </MaterialButton>
            <MaterialButton
              onClick={handleSave}
              variant="contained"
              sx={{ px: 4, height: 50, borderRadius: '8px', bgcolor: '#23ABC7', fontSize: 16, fontWeight: 700, textTransform: 'none', boxShadow: 'none', '&:hover': { bgcolor: '#159BB7', boxShadow: 'none' } }}
            >
              Lagre
            </MaterialButton>
          </DialogActions>
        </Box>
      </Dialog>

      <Box sx={{ flex: 1, minHeight: 0, width: '100%', padding: '0 24px 24px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
        {showLoadingState ? (
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '16px' }}>
            <CircularProgress size={30} sx={{ color: '#23ABC7' }} />
          </Box>
        ) : searchableData.length === 0 ? (
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '16px', color: '#64748B', fontSize: 14 }}>
            Ingen data tilgjengelig.
          </Box>
        ) : (
          <DataGrid
            getRowId={(row) => row.Username}
            onRowClick={handleRowClick}
            rows={searchableData}
            columns={columns}
            autoPageSize
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            rowHeight={52}
            headerHeight={42}
            getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
            sx={{
              bgcolor: '#FFFFFF',
              border: '1px solid #E5E7EB',
              borderRadius: '16px',
              flex: 1,
              minHeight: 0,
              boxShadow: 'none',
              '& .MuiDataGrid-columnHeaders': {
                bgcolor: '#F8FAFC',
                borderBottom: '1px solid #E5E7EB',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: 14,
                fontWeight: 600,
                color: '#334155',
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
              '& .MuiDataGrid-cell': {
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid #F1F5F9',
                borderRight: 'none',
              },
              '& .even-row': {
                bgcolor: '#FFFFFF',
              },
              '& .odd-row': {
                bgcolor: '#F8FAFC',
              },
              '& .MuiDataGrid-row:hover': {
                bgcolor: '#F1F5F9',
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none',
              },
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none',
              },
              '& .MuiDataGrid-footerContainer': {
                bgcolor: '#F8FAFC',
                borderTop: '1px solid #E5E7EB',
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
}
